module.exports = __webpack_public_path__ + "static/media/Home.b2cfc661.png";